/*
 * bst-card-atc.js — add-to-cart for the reused "Shop by Gear" (bst-card) chip on
 * collection / search pages. Mirrors the homepage bestsellers-tabs handler, but scoped to
 * the collection grid so it never double-fires with the homepage section's own handler.
 * (The flight animation is handled separately by fly-to-cart.js.)
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.bst-card__add') : null;
    if (!btn) return;
    // Only handle cards inside a collection/search product grid — the homepage bestsellers
    // section has its own identical handler.
    if (!btn.closest('.product-grid-container, .product-grid')) return;
    if (btn.closest('.bestsellers')) return;

    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.hasAttribute('disabled') || btn.dataset.busy === '1') return;
    btn.dataset.busy = '1';

    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    var labelEl = btn.querySelector('.bst-card__add-txt') || btn;
    var label = labelEl.textContent;

    // Optimistic feedback: flip to the "Added" state immediately, run the network in the
    // background, revert only if the add fails.
    btn.classList.remove('is-loading');
    btn.classList.add('is-added');
    labelEl.textContent = 'Added';
    var revertTimer = setTimeout(function () { btn.classList.remove('is-added'); labelEl.textContent = label; }, 1600);

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { return fetch(rootUrl + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: null, sourceId: 'bst-card', data: { source: 'bst-card', itemCount: cart.item_count } }
        }));
      })
      .catch(function () {
        clearTimeout(revertTimer);
        btn.classList.remove('is-added');
        labelEl.textContent = label;
      })
      .then(function () { btn.dataset.busy = ''; });
  });
})();
